// DRAFT — REVIEW ARTIFACT — NOT DEPLOYED
//
// The cycle-list data layer: a thin useQuery over list_reporting_cycles() (the light list —
// no heavy ir/params/blob columns). Mirrors useResearchHubCio's list-RPC shape.

import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { CycleStage, CycleStatus } from "@/types/ir";

type Row = Record<string, any>;

// The row shape list_reporting_cycles() RETURNS TABLE (0003c §2a). Permissive index sig so
// the list screen reads named fields without coupling to the generated Json return.
export interface ReportingCycleListRow extends Row {
  id?: string;
  period_type?: string;
  period_label?: string;
  as_of_date?: string;
  is_webinar_month?: boolean;
  status?: CycleStatus;
  current_stage?: CycleStage;
  stage_seq?: number;
  tick_count?: number;
  gate_approved?: boolean;
  approved_by?: string | null;
  approved_at?: string | null;
  last_error?: string | null;
  created_at?: string;
  updated_at?: string;
}

export function useReportingCycles() {
  return useQuery<ReportingCycleListRow[]>({
    queryKey: ["list_reporting_cycles"],
    staleTime: 2 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await (supabase as any).rpc("list_reporting_cycles", {});
      if (error) throw error;
      return ((data as ReportingCycleListRow[]) ?? []).filter(Boolean);
    },
  });
}
